export default __webpack_public_path__ + "static/media/Gellix-BlackItalic.1bd5cf09.woff2";